import React, { useEffect, useState } from "react";
import { getAdminData } from "../../Utils/role";
import { Link, useNavigate } from "react-router";
import { getVendorProfile ,profileUpdate } from "../../redux/services/authService/authApi";

const ProfileDetail = () => {
  const navigate = useNavigate();
  const [admin, setAdmin] = useState(getAdminData());

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const response = await getVendorProfile();
        const data = response?.data?.data;
        if (data) {
          setAdmin({
            ...data,
            name: data.name ,
            mobile: data.mobile || "N/A", 
            email: data.email || "-",
            status: data.status === 1 ? "Active" : "Inactive",
          });
        }
      } catch (err) {
        console.error("Profile fetch error:", err);
      }
    };
    fetchProfile();
  }, []);

  return (
    <div>
      {/* Header */}
      <div className="d-flex align-items-center justify-content-between page-header-breadcrumb">
        <div className="title_member">
          <h4>Profile Details</h4>
          <nav className="page-breadcrumb">
            <Link to="/">Home</Link>
            <span className="mx-2">/</span>
            <span>Profile Details</span>
          </nav>
        </div>

        <div>
          <button className="total-btn" onClick={() => navigate(-1)}>
            Back
          </button>
        </div>
      </div>
      <div className="main_page">
        <div className="border-0">
          <div className="d-flex profile_data">
            <div className="profile_image">
              <div className="text-center">
                <div className="profile_image_data">
                  <img
                    src={`https://ui-avatars.com/api/?name=${admin?.name || "Vendor"}&background=0D6EFD&color=fff&size=150`}
                    alt="Profile"
                    className="rounded-circle border border-3 border-primary"
                    width="130"
                    height="130"
                  />
                </div>
                <h5 className="proflename">{admin?.name || "Vendor"}</h5>
                <span
                  className={`status-badge ${
                    admin?.status === "Active" ? "active" : "inactive"
                  }`}
                >
                  <span className="status-dot"></span>
                  {admin?.status || "Inactive"}
                </span>
              </div>
            </div>
            <div className="profileeditor">
              <div className="row">
                <div className="col-md-6 mb-4">
                  <label className="form-label fw-bold">Name</label>
                  <input
                    type="text"
                    className="form-control"
                    value={admin?.name || ""}
                    readOnly
                  />
                </div>
                <div className="col-md-6 mb-4">
                  <label className="form-label fw-bold">Email</label>
                  <input
                    type="text"
                    className="form-control"
                    value={admin?.email || ""}
                    readOnly
                  />
                </div>
                <div className="col-md-6 mb-4">
                  <label className="form-label fw-bold">Vendor Id</label>
                  <input
                    type="text"
                    className="form-control"
                    value={admin?.user_id || ""}
                    readOnly
                  />
                </div>
                <div className="col-md-6 mb-4">
                  <label className="form-label fw-bold">Mobile</label>
                  <input
                    type="text"
                    className="form-control"
                    value={admin?.mobile || ""}
                    readOnly
                  />
                </div>
                <div className="col-md-6 mb-4">
                  <label className="form-label fw-bold">Assign Number</label>
                  <input
                    type="text"
                    className="form-control"
                    value={admin?.assign_number || ""}
                    readOnly
                  />
                </div>
                <div className="col-md-6 mb-4">
                  <label className="form-label fw-bold">Role</label>
                  <input
                    type="text"
                    className="form-control"
                    value={admin?.role || ""}
                    readOnly
                  />
                </div>
                <div className="col-md-6 mb-4">
                  <label className="form-label fw-bold">Kyc Status</label>
                  <input
                    type="text"
                    className="form-control"
                    value={admin?.kyc_status || ""}
                    readOnly
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileDetail;